module.exports = __webpack_public_path__ + "img/icon-radar.fad3c045.png";